<template>
    <div :ref="vehicleRef" style="height:46.5px"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
    props : ['vehicleRef'],
    data(){
        return{
            chart : null
        }
    },
    mounted(){
        this.createChart();
    },
    methods : {
        createChart(){
            this.chart = am4core.create(this.$refs[this.vehicleRef], am4charts.XYChart);
            this.chart.cursor = new am4charts.XYCursor();
            this.chart.cursor.lineX.disabled = true;
            this.chart.cursor.lineY.disabled = true;
            
            //disable panning feature
            this.chart.cursor.behavior = "none";

            this.chart.data = [{
                "date": "2012-01-01",
                "value": 8
            }, {
                "date": "2012-01-02",
                "value": 10
            }, {
                "date": "2012-01-03",
                "value": 12
            }, {
                "date": "2012-01-04",
                "value": 14
            }, {
                "date": "2012-01-05",
                "value": 11
            }, {
                "date": "2012-01-06",
                "value": 6
            }, {
                "date": "2012-01-07",
                "value": 50
            }, {
                "date": "2012-01-08",
                "value": 100
            }, {
                "date": "2012-01-09",
                "value": 13
            }, {
                "date": "2012-01-10",
                "value": 15
            }, {
                "date": "2012-01-11",
                "value": 19
            }, {
                "date": "2012-01-12",
                "value": 21
            }, {
                "date": "2012-01-13",
                "value": 22
            }, {
                "date": "2012-01-14",
                "value": 20
            }, {
                "date": "2012-01-15",
                "value": 95
            }, {
                "date": "2012-01-16",
                "value": 100
            }, {
                "date": "2012-01-17",
                "value": 16,
                "opacity": 0
            }, {
                "date": "2012-01-18",
                "value": 18
            }, {
                "date": "2012-01-19",
                "value": 17
            }, {
                "date": "2012-01-20",
                "value": 15
            }, {
                "date": "2012-01-21",
                "value": 12
            }, {
                "date": "2012-01-22",
                "value": 10
            }, {
                "date": "2012-01-23",
                "value": 8
            }];

            let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.dataFields.category = "Date";
            dateAxis.renderer.grid.template.location = 0.5;
            dateAxis.dateFormatter.inputDateFormat = "yyyy-MM-dd";
            dateAxis.renderer.minGridDistance = 40;
            dateAxis.tooltipDateFormat = "MMM dd, yyyy";
            dateAxis.dateFormats.setKey("day", "dd");

            let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

            dateAxis.renderer.grid.template.disabled = true;
            dateAxis.renderer.labels.template.disabled = true;
            valueAxis.renderer.grid.template.disabled = true;
            valueAxis.renderer.labels.template.disabled = true

            var lineSeries = this.chart.series.push(new am4charts.LineSeries());
            lineSeries.dataFields.valueY = "value";
            lineSeries.dataFields.dateX = "date";
            lineSeries.name = "Sales";
            lineSeries.stroke = am4core.color('#' + (0x1000000 + Math.floor(Math.random() * 0x1000000)).toString(16).substr(1))
            lineSeries.strokeWidth = 3;

        }
    }

}
</script>